import api from "./api.js";

export default class LectureApi {
  static async getCategoryList(data) {
    return await api.get(`api/lecture-category`, data);
  }

  static async getList(data) {
    return await api.get(`api/lecture-video`, data);
  }

  static async getDetail(id, data) {
    return await api.get(`api/lecture-video/${id}`, data);
  }

  static async getCurriculumList(data) {
    return await api.get(`api/lecture-curriculum`, data);
  }

  static async getCurriculumDetail(id, data) {
    return await api.get(`api/lecture-curriculum/${id}`, data);
  }

  static async putScrap(data) {
    return await api.patch(`api/lecture-scrap`, data);
  }

  // ---------- 강의실 ---------- //
  static async getMemberList(data) {
    return await api.get(`api/member-lecture`, data);
  }

  static async getMemberDetail(id, data) {
    return await api.get(`api/member-lecture/${id}`, data);
  }

  static async updateMember(id, data) {
    return await api.patch(`api/member-lecture/${id}`, data);
  }

  static async lectureCheck(data) {
    return await api.get(`api/member-lecture/check`, data);
  }

  static async onBoardinglectureList(data) {
    return await api.get(`api/lecture-video/onboarding/recommend`, data);
  }
}
